import { env } from '@/services/dev';
import utils from '@/services/tools';
import http from '@/services/http';

// 企业编号
const CORP_ID = 'wwaf3a87ef69d4242f';

// config js sdk api
const JS_API_LIST_FOR_CONFIG = [
  'agentConfig',
  'setClipboardData',
  'openDefaultBrowser',
  'previewFile',
  'chooseImage',
  'openLocation',
  'getLocation',
  'openEnterpriseChat',
  'closeWindow',
];

// agent config js sdk api
const JS_API_LIST_FOR_AGENT_CONFIG = [
  'selectExternalContact',
  'openUserProfile',
  'thirdPartyOpenPage',
  'getCurExternalContact',
  'shareToExternalContact',
  'sendChatMessage',
];

export default {
  getWorkWxAuth() {
    // 没有openid则跳转微信登录获取
    location.replace(this.getWorkWxAuthUrl());
  },

  /**
   * 获取企业微信登录链接
   */
  getWorkWxAuthUrl() {
    const ranNum = Math.random().toString();

    // 后端地址
    // const redirectUri = encodeURIComponent(`https://${env.env}api.666visa.cn/www/open/wxmp_redirect`);

    // 加随机数是在有些安卓微信上登陆回来不刷新页面
    const stateUrl = `${location.origin}/${
      location.search ? `${location.search}&v=` : '?v='
    }${ranNum}${location.hash}`;

    // 前端地址
    // const state = encodeURIComponent(base64.encode(stateUrl));
    const state = encodeURIComponent(stateUrl);

    // 登录跳转地址
    // return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${CORP_ID}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_base&state=${state}#wechat_redirect`;
    return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${CORP_ID}&redirect_uri=${state}&response_type=code&scope=snsapi_base&state=#wechat_redirect`;
  },

  // 微信js配置获取
  workWxConfigGet(configUrl = '/wwx/open/wwx_config_get') {
    return new Promise((resolve, reject) => {
      const url = location.href.split('#')[0];
      http
        .wwxPost(`${env.apiBase}${configUrl}`, { url })
        .then((res) => {
          const { data, err } = utils.getResponseData(res);
          if (data) {
            resolve(data);
          } else {
            reject(err);
          }
        })
        .catch(reject);
    });
  },

  // 配置与分享
  workWxAgentConfig(configUrl) {
    return new Promise((resolve, reject) => {
      this.workWxConfigGet(configUrl)
        .then((data) => {
          ww.register({
            corpId: data.agent.corpid, // 必填，企业微信的corpid，必须与当前登录的企业一致
            agentId: data.agent.agentid, // 必填，企业微信的应用id----1000055-1000056-1000057：开发 测试 正式

            jsApiList: [
              ...JS_API_LIST_FOR_CONFIG,
              ...JS_API_LIST_FOR_AGENT_CONFIG,
            ], // 必填------如果返回的没有getCurExternalContact等客户权限，到客户与上下游-》客户-》API文档-》可调用接口的应用添加应用
            getAgentConfigSignature: async () => {
              return {
                timestamp: data.agent.timestamp,
                nonceStr: data.agent.noncestr,
                signature: data.agent.signature,
              };
            },
            getConfigSignature: async () => {
              return {
                timestamp: data.corp.timestamp,
                nonceStr: data.corp.noncestr,
                signature: data.corp.signature,
              };
            },
          });
          resolve();
        })
        .catch(reject);
    });
  },

  // 打开聊天窗口
  openEnterpriseChat(externalUserId) {
    if (!externalUserId) {
      console.log('external_user_id没有');
      return;
    }

    return new Promise((resolve, reject) => {
      this.workWxAgentConfig().then(() => {
        ww.openEnterpriseChat({
          // 注意：userIds和externalUserIds至少选填一个。内部群最多2000人；外部群最多500人；如果有微信联系人，最多40人
          // externalUserIds: 'wmZUg0BgAAnmfQvcBw2jm7NrGYWFF-PA', // 参与会话的外部联系人列表，格式为userId1;userId2;…，用分号隔开。
          externalUserIds: externalUserId || '',
          groupName: '', // 会话名称。单聊时该参数传入空字符串""即可。
          chatId: '', // 若要打开已有会话，需指定此参数。如果是新建会话，chatId必须为空串
          success() {
            resolve();
          },
          fail(e) {
            reject(e);
          },
        });
      });
    });
  },

  // 获取当前外部联系人的信息
  getCurExternalContactInfo() {
    return new Promise((resolve, reject) => {
      ww.getCurExternalContact({
        success: function (res) {
          var userId = res.userId; //返回当前外部联系人userId
          resolve(userId);
        },
        fail: function (err) {
          reject(err);
        },
      });
    });
  },
};
